// extracted by mini-css-extract-plugin
module.exports = {"header":"ChangeAddressFormModal_header_1rhlV","closeIcon":"ChangeAddressFormModal_closeIcon_e_bIo"};